
import { mapActions, mapMutations, mapState } from "vuex";
import contentMixins from "@/mixins/contentMixins";
import dateMixin from "@/mixins/dateMixins";
import News from "@/graphql/news";

export default {
  mixins: [contentMixins, dateMixin],
  name: "NewsList",
  nuxtI18n: {
    paths: {
      "en-ca": "/news",
      "fr-ca": "/actualites",
    },
  },
  async asyncData({ app, store, i18n }) {
    const client = app.apolloProvider.defaultClient;
    const locale = i18n.locale.slice(0, 3) + i18n.locale.slice(3).toUpperCase();
    const newsResponse = await client.query({
      query: News,
      variables: {
        limit: store.state.newsLimit,
        sort: "Date:desc",
        locale: locale,
      },
    });
    const actualites = newsResponse.data.actualites.data;
    const listeActualite = newsResponse.data.listeActualite.data.attributes;
    const totalActualites = newsResponse.data.actualites.meta.pagination.total;
    return { actualites, listeActualite, totalActualites };
  },
  data() {
    return {
      show: false,
    };
  },
  head() {
    return {
      title: this.listeActualite.SEO.MetaTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.listeActualite.SEO.MetaDescription,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.listeActualite.SEO.MetaTitle,
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => this.setPageAnimation("animBanner"), 500);
  },
  methods: {
    ...mapActions(["setNewsLimit"]),
    ...mapMutations({
      setPageAnimation: "SET_PAGE_ANIMATION",
    }),
    buttonClick() {
      this.setNewsLimit(this.newsLimit + 2);
    },
  },
  computed: {
    ...mapState(["newsLimit"]),
  },
  watch: {
    newsLimit() {
      this.$nuxt.refresh();
    },
  },
};
